<div provide-parent-form>
    <div class="w-100 required">
        <br/>
        <label class="w-100" for="adaSeating" aria-labelledby="adaSeating">
        <span [innerHTML]="'copy.label.GUEST.adaSeatingLabel'|copy|async"></span>
        </label>
        <mat-radio-group class="w-100" [(ngModel)]="adaSeating.Value" name="adaSeatingValue_{{guest.$mtcUUID}}" #adaSeatingValue="ngModel" required>
        <mat-radio-button value="Yes">Yes</mat-radio-button>
        <mat-radio-button value="No">No</mat-radio-button>
        <mat-error><app-validation [object]="adaSeatingValue" isRequired="true"></app-validation></mat-error>
        </mat-radio-group>  
    </div>
</div>
